<template>
  <!-- Scrollable List Container -->
  <div style="max-height: 500px; overflow-y: auto;">
    <v-list>
      <div class="ma-2" v-for="(log, index) of jobLogs" :key="index">
        <v-list-item dense :style="index % 2 == 0 ? 'background-color: lightgrey' : ''"> {{ log }} </v-list-item>
      </div>
    </v-list>
  </div>
</template>

<script>
export default {
  data() {
    return {
    };
  },
  components: {},
  props: ["jobLogs"],
  methods: {},
};
</script>

<style lang="scss" scoped></style>
